import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './session.schema.yaml';

class SessionFeature extends AbstractFeature {
    get name() {
        return 'Session';
    }

    get configSchema() {
        return SCHEMA;
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            Inactivity: {
                inactivityTimeSec: this.config.inactivityTimeSec,
                inactivityMessageTimeSec: this.config.inactivityMessageTimeSec,
            },
        });

        super.updateViewsConfig(viewsConfig);
    }
}

export const Session = new SessionFeature(allFeatures);
